import { render, staticRenderFns } from "./SectionModelList.vue?vue&type=template&id=1dcda64c"
import script from "./SectionModelList.vue?vue&type=script&lang=js"
export * from "./SectionModelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports